import axios from "axios";

export function getChallenge() {
  return axios.get("/challenge");
}

export function login(payload) {
  return axios.post("/login", payload);
}

export function getToken(payload) {
  return axios.post('/sanctum/token', payload);
}

export function poll(payload) {
  return axios.post('/sanctum/poll', payload)
}

export function logout() {
  return axios.post('/logout')
}


